import React from "react";

/** Sub-category: a parent item with indented children. */
const SubCategoryIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="2 2.5 20 18.5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="3.5" width="7" height="5" rx="1.2" stroke="currentColor" strokeWidth="1.7" />
      <path d="M6.5 8.5v9.5h4M6.5 12.5h4" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="12.5" y="10.5" width="8.5" height="4" rx="1" fill="currentColor" />
      <rect x="12.5" y="16" width="8.5" height="4" rx="1" fill="currentColor" />
    </svg>
  );
};

export default SubCategoryIcon;
